var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurePrivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30.004,
    viewBox: "0 0 30 30.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4838",
    "data-name": "Rectangle 4838",
    width: 30,
    height: 30.004,
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10124",
    "data-name": "Group 10124",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10123",
    "data-name": "Group 10123",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M14.125,24.254a1.94,1.94,0,1,1-.969.005l0-1.036H7.842l0,1.036a1.935,1.935,0,1,1-.976,0l.005-1.52a.474.474,0,0,1,.485-.481h5.8v-.969H8.809a.475.475,0,0,1-.485-.486V14.035a.5.5,0,0,1,.54-.491h.427V12.1A4.355,4.355,0,1,1,18,12.157v1.385l.489.005a.477.477,0,0,1,.48.489V20.8a.476.476,0,0,1-.485.486h-4.35v.969l5.739,0c.272,0,.534.145.536.431l.015,1.574a1.938,1.938,0,1,1-.978,0V23.223H14.132Zm1.941-12.076,0,1.369h.969V12.093a3.385,3.385,0,0,0-6.769-.061l0,1.515h.969V12.092a2.421,2.421,0,1,1,4.84.086M15.1,13.545V12.092a1.451,1.451,0,0,0-2.9,0v1.456ZM18,20.319v-5.8H9.29v5.808ZM7.172,25.183A.963.963,0,1,0,8.3,25.94a.958.958,0,0,0-1.129-.757m6.29,0a.963.963,0,1,0,1.129.757.957.957,0,0,0-1.129-.757m6.288,0a.963.963,0,1,0,1.131.757.957.957,0,0,0-1.131-.757",
    transform: "translate(1.355 1.935)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M21.757,7.456a6.763,6.763,0,0,0-13.515,0,.487.487,0,0,1-.605.464,5.321,5.321,0,1,0-1.4,10.464l2.471,0v.969H6.3A6.288,6.288,0,1,1,7.319,6.861a7.731,7.731,0,0,1,15.364,0A6.288,6.288,0,1,1,23.76,19.353H21.291v-.966l2.531-.007A5.318,5.318,0,1,0,22.364,7.919a.488.488,0,0,1-.606-.462",
    transform: "translate(0 0)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5675",
    "data-name": "Path 5675",
    d: "M16.838,7.353A4.847,4.847,0,0,0,12,2.516V1.548a5.812,5.812,0,0,1,5.8,5.8Z",
    transform: "translate(3 0.387)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5676",
    "data-name": "Path 5676",
    d: "M12.776,17.8l-.969,0,0-1.05a1.454,1.454,0,1,1,.959,0Zm-.61-2.877a.475.475,0,0,0-.325.632.48.48,0,1,0,.325-.632",
    transform: "translate(2.71 3.483)",
    fill: "#d13c3c",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePrivate);
export default __webpack_public_path__ + "static/media/secure_private.39044478824e9dde35b418cbc1286746.svg";
export { ForwardRef as ReactComponent };